<!--!!!!!!!!!!!!Currently not in use!!!!!!!!!!!!-->
<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerText]="T.ROOM_MEDIA_SCREEN_SELECTION_DIALOG_HEADER | translate"
>
	<!--
  <div additionalHeader>
    <div class="top">
      <div class="removeIcon">
        <i class="fad fa-"></i>
      </div>
      <div class="innerContent">
        <div class="title mat-h2 nomargin">Select Media Screens</div>
      </div>
    </div>
  </div>-->
	<div dialogContent>
		<div class="bottom">
			<div class="text">
				<div style="width: 90%; height: 100%">
					<div class="row">
						<div class="col-lg-10 col-md-10 col-sm-10">
							@if (playerList) {
								<table class="table table-bordered table-responsive-md table-striped">
									<colgroup>
										<col style="width: 80%" />
										<col style="width: 10%" />
									</colgroup>
									<thead>
										<tr>
											<th>
												{{ T.CONFIGURATION_EDITOR_TRAINING_ROOM_ASSIGNED_MEDIASCREENS | translate }}
											</th>
											<th>
												{{ T.CONFIGURATION_EDITOR_TRAINING_ROOM_ACTIONS | translate }}
											</th>
										</tr>
									</thead>
									<tbody>
										@for (playerId of data.trainingRoom?.mediaScreenDeviceIds; track playerId) {
											<tr>
												<td>
													{{ getPlayerName(playerId) }}
												</td>
												<td>
													<button
														type="button"
														class="btn btn-danger btn-xs"
														(click)="removePlayer(playerId, data.trainingRoom.mediaScreenDeviceIds)"
													>
														<i class="fas fa-times"></i>
													</button>
												</td>
											</tr>
										}
									</tbody>
									<tfoot>
										<tr>
											<td>
												<select [(ngModel)]="selectedPlayerId" style="width: 100%">
													@for (player of filteredPlayerList(); track player) {
														<option [ngValue]="player.value.id">
															{{ player.value.name }}
														</option>
													}
													<option [ngValue]="null">
														{{ T.CONFIGURATION_EDITOR_TRAININGROOM_NO_MEDIASCREEN | translate }}
													</option>
												</select>
											</td>
											<td>
												<button
													type="button"
													class="btn btn-default btn-xs"
													[attr.data-selected-input-channel]="selectedPlayerId"
													[ngClass]="{
														inactive: !selectedPlayerId,
													}"
													(click)="addPlayer(selectedPlayerId, data.trainingRoom.mediaScreenDeviceIds)"
												>
													<i class="fas fa-plus"></i>
												</button>
											</td>
										</tr>
									</tfoot>
								</table>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="ok()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
